module.exports = __webpack_public_path__ + "static/Light Website Photo-2182089366503ddf5f8dd9dd7948c70e.jpg";